export default __webpack_public_path__ + "static/media/grotta.3b1151ce.jpg";